export default __webpack_public_path__ + "static/media/wegovy-twist-on-needle.d1c9dfb7.mp4";